import * as firebase from "firebase/app";
import "firebase/auth";
import "firebase/database";

const config = {
    apiKey: 'AIzaSyAcBIJr7e2aTj6Gp4Y_ioZgENhFM-c0DCo',
    authDomain: 'ttgif-3c665.firebaseapp.com',
    databaseURL: 'https://ttgif-3c665.firebaseio.com',
    projectId: 'ttgif-3c665',
    storageBucket: 'ttgif-3c665.appspot.com',
    messagingSenderId: '927756123615'
};

if (!firebase.apps.length) {
  firebase.initializeApp(config);
}

export const auth = firebase.auth();
export const db = firebase.database();


// WEBPACK FOOTER //
// ./src/firebase/firebase.ts